import { useContext, useEffect } from 'react';

import { CloseButton } from '@/components/old';

import ModalContext from '../../../contexts/Modal/ModalContext';

import './ModalConstructor.scss';

export enum ModalBorderTopColor {
  yellow = '#ffdf17',
  blue = '#1E4DBA',
  red = '#d8222f',
}

interface Props extends React.PropsWithChildren {
  modalBorderTopColor: ModalBorderTopColor;
  closable?: boolean;
  onCancel?: () => void;
}

export const ModalConstructor: React.FC<Props> = ({ children, modalBorderTopColor, closable = true, onCancel }) => {
  const { isModalOpen, toggleModal } = useContext(ModalContext);

  const handleCancel = (): void => {
    if (onCancel) {
      onCancel();
      return;
    }

    toggleModal(false);
  };

  useEffect(() => {
    isModalOpen && (document.body.style.overflow = 'hidden');
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  return (
    <>
      <div className="modal-window" style={{ borderTopColor: modalBorderTopColor }}>
        {children}

        {closable && (
          <CloseButton
            id="close-modal"
            aria-label="Close modal window"
            className="modal-window__close-btn"
            isDefault={true}
            onClick={handleCancel}
          />
        )}
      </div>

      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="close-modal" className="modal-window__close-area" />
    </>
  );
};
